export const BUYER_DOMAIN_TYPE = 'buyer';
export const SELLER_DOMAIN_TYPE = 'seller';
export const EXTERNAL_DOMAIN_TYPE = 'external';

export const METRO_MARKETS_COLUMN = 'footer_metro_markets';
export const FOR_BUYERS_COLUMN = 'footer_for_buyers';
export const FOR_SELLERS_COLUMN = 'footer_for_sellers';

export const LEGAL_PAGES = 'sub_footer';
export const FOR_PAYMENT_IMAGES = 'footer_for_payments';
export const SUPPORT_PHONE_NUMBER = 'support_phone_number';
export const SUPPORT_PHONE_NUMBER_B2B = 'support_phone_number_b2b';
export const SUPPORT_PHONE_DISCLAIMER = 'support_phone_disclaimer';
export const SUPPORT_PHONE_NUMBER_SUBSIDIARY = 'support_phone_number_subsidiary';
export const TELESALES_PHONE_NUMBER = 'telesales_phone_number';
export const SUBSIDIARY_CONTACT_EMAIL = 'subsidiary_contact_email';
export const FRESHDESK_INSTANCE_LINK = 'freshdesk_instance_link';
export const HELP_CENTER_LINK = 'help_center_link';
export const FOOTER_NAVIGATION_LINKS = 'footer_navigation_links';
export const TITLE = 'title';
export const LINKS = 'links';
